import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Building2, Key, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Services = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Building2,
      titleKey: 'trading',
      color: '#C4A55A'
    },
    {
      icon: Key,
      titleKey: 'rental',
      color: '#B8974E'
    },
    {
      icon: TrendingUp,
      titleKey: 'investment',
      color: '#D4B56A'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-black to-[#1a1a1a] relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C4A55A] to-transparent" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.services.title}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            const serviceData = t.services[service.titleKey];
            
            return (
              <Card
                key={index}
                className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-[#C4A55A]/20 hover:border-[#C4A55A]/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-[#C4A55A]/20 group backdrop-blur-sm"
              >
                <CardHeader>
                  <div
                    className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#C4A55A]/20 to-[#C4A55A]/5 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300"
                  >
                    <Icon className="h-8 w-8" style={{ color: service.color }} />
                  </div>
                  <CardTitle className="text-2xl text-white group-hover:text-[#C4A55A] transition-colors duration-300">
                    {serviceData.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-400 text-base leading-relaxed">
                    {serviceData.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};